import {
  Component,
  Input,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  TranslateModule,
  TranslatePipe,
  TranslateService,
} from '@ngx-translate/core';
import { Router } from '@angular/router';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { YoutubePlayerComponent } from '../youtube-player/youtube-player.component';
import { PopupComponent } from '../popup/popup.component';
import { IPopup } from '../popup/popup.model';
import { BaseComponent } from '../../Pages/base.component';
import { SchoolApiService } from '../../Services/schoolApi.service';
import { Utils } from '../../utils';
import { UrlDetectorPipe } from '../../Services/urlDetector.pipe';
import { IAttachment } from '../../Models/attachment.model';
import { DOMAIN } from '../../../configurations/defaultConfigs';

@Component({
  selector: 'app-articles-view',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    MatDialogModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    YoutubePlayerComponent,
    PopupComponent,
    UrlDetectorPipe,
  ],
  providers: [TranslateService, TranslatePipe, SchoolApiService],
  templateUrl: './articles-view.component.html',
  styleUrl: './articles-view.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ArticlesViewComponent extends BaseComponent {
  @Input() articles: Array<IPopup> = [];
  @Input() itemsPerPage: number = 3;
  @Input() totalcount: number = 0;
  @Input() articleSection?: string;
  @Input() hideReadMore: boolean = false;
  @Input() override articleType!: string;
  @Output() onPaginateEvent = new EventEmitter<number>();

  currentPage: number = 1;
  selectedArticle: IPopup;

  constructor(
    private dialog: MatDialog,
    schoolApiService: SchoolApiService,
    readonly cdr: ChangeDetectorRef,
    private router: Router,
  ) {
    super(schoolApiService);
  }

  get totalPages(): number {
    return Math.ceil(this.totalcount / this.itemsPerPage) || 1;
  }

  get totalPagesArray(): number[] {
    return Array.from({ length: this.totalPages }, (_, i) => i + 1);
  }

  changePage(page: number): void {
    if (page < 1 || page > this.totalPages) return;
    this.currentPage = page;
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    this.onPaginateEvent.emit(startIndex);
    Utils.navigateToTop(this.articleSection);
  }

  openArticle(article: IPopup): void {
    this.selectedArticle = article;
    this.dialog.open(PopupComponent, {
      data: article,
      maxWidth: '90%',
      height: '70%',
      position: { top: '10%', left: '15%' },
    });
  }

  downloadPdf(pdf: IAttachment): void {
    if (!pdf) return;
    this.schoolApiService
      .downloadPDF(DOMAIN, this.articleType, pdf.physicalName, pdf.originName)
      .subscribe((blob: any) => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = pdf.originName;
        link.click();
        window.URL.revokeObjectURL(url);
      });
  }
}
